// Shared motion vocabulary — use these instead of inline framer-motion configs
// so the whole app moves with one rhythm.
//
// Easing: ease-out-expo (refined, decelerating curve).
// Durations: fast 150ms, base 240ms, slow 420ms — matches CSS vars in index.css.

export const easings = {
  outExpo: [0.16, 1, 0.3, 1],
  editorial: [0.65, 0, 0.35, 1],
};

export const durations = {
  fast: 0.15,
  base: 0.24,
  slow: 0.42,
};

// Drop-in framer-motion variants.
export const fadeUp = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: durations.slow, ease: easings.outExpo },
};

export const fade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: durations.base, ease: easings.outExpo },
};

// Staggered list — apply to a parent <motion.div>.
export const stagger = {
  initial: {},
  animate: { transition: { staggerChildren: 0.06, delayChildren: 0.05 } },
};

// Helper: fadeUp with a delay index (0,1,2,...).
export const fadeUpAt = (i = 0) => ({
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: durations.slow, ease: easings.outExpo, delay: i * 0.06 },
});
